import { NumericFormat } from 'react-number-format';
import React from 'react';

export const PriceInput = ({ value, handleChange, name, placeholder, disabled, decimalScale, ref }) => {
    return (
        <div ref={ref}>
            <NumericFormat
                value={value === 0 ? 0.0 : value}
                onChange={handleChange}
                name={name}
                thousandSeparator={true}
                fixedDecimalScale={true}
                decimalSeparator="."
                allowNegative={false}
                isNumericString
                prefix={'$'}
                placeholder={placeholder}
                decimalScale={decimalScale ? decimalScale : 4}
                disabled={disabled}
            />
        </div>
    );
};
